import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button"; // Import Button
import TextField from "@mui/material/TextField"; // Import TextField
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import MemberService from "../../services/MemberService";
import { calculateAge } from "../../Utils/DateUtils";
import Profile from "../Profile/Profile";

const translateGender = (genderId) => {
  switch (genderId) {
    case 1:
      return "Male";
    case 2:
      return "Female";
    default:
      return "Unknown";
  }
};

const MembersFullList = () => {
  const [members, setMembers] = useState([]);
  const [page, setPage] = useState(0);
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMembers();
  }, [page, rowsPerPage]);

  const fetchMembers = async () => {
    try {
      let response;
      if (search === "") {
        response = await MemberService.getPaginatedMembers(
          page,
          rowsPerPage,
          search
        );
      } else {
        response = await MemberService.search(search, page, rowsPerPage);
      }
      setMembers(response.data.memberList);
      setTotalRecordCount(response.data.recordCount);
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  const handleSearch = async () => {
    setPage(0); // Reset to first page
    fetchMembers();
  };

  const handleClearSearch = () => {
    setSearch("");
    setPage(0); // Reset to first page
    fetchMembers();
  };

  const handleProfileClick = (memberId) => {
    setSelectedMemberId(memberId);
    setIsProfileOpen(true);
  };

  const handleCloseProfile = () => {
    setIsProfileOpen(false);
    setSelectedMemberId(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  return (
    <>
      <Paper style={{ margin: "20px", width: "95%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "16px",
          }}
        >
          <TextField
            label="Search"
            variant="outlined"
            value={search}
            onChange={handleSearchChange}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                handleSearch();
              }
            }}
            style={{ marginRight: "16px", flex: 1 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleSearch}
            style={{ marginRight: "8px" }}
          >
            Search
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClearSearch}
          >
            Clear
          </Button>
        </div>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{ fontWeight: "bold", backgroundColor: "lightgray" }}
                >
                  ID
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", backgroundColor: "lightgray" }}
                >
                  Last Name
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", backgroundColor: "lightgray" }}
                >
                  First Name
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", backgroundColor: "lightgray" }}
                >
                  Age
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", backgroundColor: "lightgray" }}
                >
                  Gender
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", backgroundColor: "lightgray" }}
                >
                  Plan
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", backgroundColor: "lightgray" }}
                >
                  Phone
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", backgroundColor: "lightgray" }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {members.map((member) => (
                <TableRow key={member.id}>
                  <TableCell>{member.id}</TableCell>
                  <TableCell>{member.lastName}</TableCell>
                  <TableCell>{member.firstName}</TableCell>
                  <TableCell>{calculateAge(member.dob)}</TableCell>
                  <TableCell>{translateGender(member.gender)}</TableCell>
                  <TableCell>{member.plan}</TableCell>
                  <TableCell>{member.phone}</TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => handleProfileClick(member.id)}
                      sx={{ "&:hover": { color: "blue" } }}
                    >
                      <AccountCircleIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 20, 50]}
          component="div"
          count={totalRecordCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      {isProfileOpen && (
        <Profile
          memberId={selectedMemberId}
          isOpen={isProfileOpen}
          onClose={handleCloseProfile}
        />
      )}
    </>
  );
};

export default MembersFullList;
